import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Import components

//public components
import RegisterForm from './components/RegisterForm';
import LoginForm from './components/LoginForm';

//auth components
import DebugMe from './components/Debug';
import RequireAuth from './authHelpers/RequireAuth';
import AuthCallback from './authHelpers/AuthCallback';

//private components
import Profile from './components/Profile';
import Preferences from './components/Preferences';
import ProfileDeletion from './components/DeleteProfile';
import LogoutButton from './components/LogoutButton';
import ProfilePicture from './components/EditImage';
import FrontPage from './components/LandingPage';
import AgeInfo from './components/AgeInfo';
import LocationInfo from './components/LocationInfo';
import SexInfo from './components/SexInfo';
import SeekingInfo from './components/SeekingInfo';
import CareerInfo from './components/CareerInfo';
import PoliticalInfo from './components/PoliticalInfo';
import KidsInfo from './components/KidsInfo';
import EthnicityInfo from './components/EthnicityInfo';
import DrinkingSmokingInfo from './components/DrinkingSmokingInfo';
import PetsInfo from './components/PetsInfo';
import LanguageInfo from './components/LanguageInfo';
import AlmostDone from './components/AlmostDone';
import ChatPage from './components/ChatPage';
import ChatWindow from './components/ChatWindow';
import PersonalityTest from './components/PersonalityTest';
import ProcessingPersonality from './components/ProcessingPersonality';
import PersonalityResult from './components/PersonalityResult';
import InterestsHobbiesInfo from './components/InterestsHobbiesInfo';
import DateActivitiesInfo from './components/DateActivitiesInfo';
import OtherQuestionsInfo from './components/OtherQuestionsInfo';

const AppRouter = () => {
  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<RegisterForm />} />
        <Route path="/login" element={<LoginForm />} />
        <Route path="/auth/callback" element={<AuthCallback />} />

        {/* Private Routes Wrapped in RequireAuth */}
        <Route element={<RequireAuth />}>
          <Route path="/profile" element={<Profile />} />
          <Route path="/preferences" element={<Preferences />} />
          <Route path="/profile/delete" element={<ProfileDeletion />} />
          <Route path="/profile/logout" element={<LogoutButton />} />
          <Route path="/profile/image" element={<ProfilePicture />} />
          <Route path="/frontpage" element={<FrontPage />} />
          <Route path="/age-info" element={<AgeInfo />} />
          <Route path="/location-info" element={<LocationInfo />} />
          <Route path="/sex-info" element={<SexInfo />} />
          <Route path="/seeking-info" element={<SeekingInfo />} />
          <Route path="/career-info" element={<CareerInfo />} />
          <Route path="/political-info" element={<PoliticalInfo />} />
          <Route path="/kids-info" element={<KidsInfo />} />
          <Route path="/ethnicity-info" element={<EthnicityInfo />} />
          <Route
            path="/drinking-smoking-info"
            element={<DrinkingSmokingInfo />}
          />
          <Route path="/pets-info" element={<PetsInfo />} />
          <Route path="/language-info" element={<LanguageInfo />} />
          <Route path="/almost-done" element={<AlmostDone />} />
          <Route path="/chats" element={<ChatPage />} />
          <Route path="/chat/:userId" element={<ChatWindow />} />
          <Route path="/personality-test" element={<PersonalityTest />} />
          <Route
            path="/processing-personality"
            element={<ProcessingPersonality />}
          />
          <Route path="/personality-result" element={<PersonalityResult />} />
          <Route path="/interests-hobbies" element={<InterestsHobbiesInfo />} />
          <Route path="/date-activities" element={<DateActivitiesInfo />} />
          <Route path="/other-questions" element={<OtherQuestionsInfo />} />
          <Route path="/debug-me" element={<DebugMe />} />
          {/* Define other routes here */}
        </Route>
      </Routes>
    </Router>
  );
};

export default AppRouter;
